import React, { useState, useCallback } from "react";
import { 
  SuccessMessage,
  FailMessage,
  Loading,
  FormatValueToDecimal,
  CompanySelect,
  FormatDateToMDY,
  DateSelect,
  FormatDateToWord
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import NoAccess from "../NoAccess";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

export default function SalesRegister() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
//#endregion






//#region Variables 
  const [company, setCompany] = useState(null);
  const today = new Date().toISOString().split("T")[0];
  const [dateFrom, setDateFrom] = useState(today);
  const [dateTo, setDateTo] = useState(today);
//#endregion






//#region Generate
  const fetchReportData = useCallback(async (_data) => {
    const body = {
      dateFrom: dateFrom,
      dateTo: dateTo,
    }

    try {
      // const response = await axios.post(`${apiUrl}/api/Report/report-data/statement-of-account`, body, {
      const response = await axios.post(`${apiUrl}/api/Report/report-data/sales-register`, body, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, [dateFrom, dateTo]);

  const generateHandleClick = async () => {
    if(!dateFrom || !dateTo || !company){
      setFailMessage("Please fill up required fields")
      return;
    }

    setLoading(true)

    const _data = await fetchReportData();

    try {
      // Load the existing PDF template
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER.pdf`;
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);
      // let page = pdfDoc.getPages()[0];

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const drawHeader = (targetPage) => {
        // Header Info
        targetPage.drawText(company.name?.toString() ?? "", {
          x: 35, y: 741, size: 16, font: calibriBold, color: rgb(0, 0, 0),
        });

        targetPage.drawText(company.address?.toString() ?? "", {
          x: 35, y: 731, size: 9, font: calibriFont, color: rgb(0, 0, 0),
        });

        targetPage.drawText(company.tin?.toString() ?? "", {
          x: 35, y: 721, size: 9, font: calibriFont, color: rgb(0, 0, 0),
        });

        targetPage.drawText("", {
          x: 35, y: 580, size: 11, font: calibriBold, color: rgb(0, 0, 0),
        });

        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, {
          x: 265,
          y: 635,
          size: 9,
          font: calibriBold,
          color: rgb(0, 0, 0),
        });
      };

      let currentPage = pdfDoc.getPages()[0];
      drawHeader(currentPage);

      // TABLE LOGIC
      let yPosition = 540;
      const bottomThreshold = 60; // When to trigger a new page

      let totalVatable = 0;
      let totalVAT = 0;
      let totalSubTotal = 0;
      let totalDiscount = 0;
      let overallTotal = 0;

      for (let index = 0; index < _data?.length; index++) {
        if (yPosition < bottomThreshold) {
          currentPage = pdfDoc.addPage([currentPage.getWidth(), currentPage.getHeight()]);
          drawHeader(currentPage);
          yPosition = 540; 
        }

        const itemData = _data[index];

        const accounts = [...new Map(
            (itemData.salesAccounts || []).map(acc => [acc.glAccountId, acc])
        ).values()]
        .map(acc => `${acc.glAccountNumber} - ${acc.glAccountName}`)
        .join(", ");
        
        currentPage.drawText(`${FormatDateToMDY(itemData.date)}`, { x: 30, y: yPosition - 8, size: 9, font: calibriFont });
        currentPage.drawText(`${itemData.referenceNumber ?? "-"}`, { x: 30, y: yPosition, size: 9, font: calibriFont });
        currentPage.drawText(`${itemData.customerName1 ?? "-"}`, { x: 110, y: yPosition, size: 9, font: calibriFont });
        currentPage.drawText(`${itemData.customerCustomerId ?? "-"}`, { x: 110, y: yPosition - 8, size: 9, font: calibriFont });
        currentPage.drawText(`${accounts ?? "-"}`, { x: 190, y: yPosition, size: 9, font: calibriFont });
        currentPage.drawText(FormatValueToDecimal((itemData.subTotal ?? 0) - (itemData.vat ?? 0))?.toString() ?? "", { x: 290, y: yPosition, size: 9, font: calibriFont, color: rgb(0, 0, 0) });
        currentPage.drawText(FormatValueToDecimal(itemData.vat)?.toString() ?? "", { x: 342.5, y: yPosition, size: 9, font: calibriFont, color: rgb(0, 0, 0) });
        currentPage.drawText(FormatValueToDecimal(itemData.subTotal)?.toString() ?? "", { x: 382.5, y: yPosition, size: 9, font: calibriFont, color: rgb(0, 0, 0) });
        currentPage.drawText(FormatValueToDecimal(itemData.discounts)?.toString() ?? "", { x: 442, y: yPosition, size: 9, font: calibriFont, color: rgb(0, 0, 0) });
        currentPage.drawText(FormatValueToDecimal(itemData.totalAmount)?.toString() ?? "", { x: 495, y: yPosition, size: 9, font: calibriFont, color: rgb(0, 0, 0) });
        currentPage.drawText(itemData.status ?? "", { x: 546, y: yPosition, size: 9, font: calibriFont, color: rgb(0, 0, 0) });

        totalVatable += ((itemData.subTotal ?? 0) - (itemData.vat ?? 0));
        totalVAT += itemData.vat;
        totalSubTotal += itemData.subTotal;
        totalDiscount += itemData.discounts;
        overallTotal += itemData.totalAmount;

        // Adjust yPosition for the next entry
        yPosition -= 25;
      }

      if (yPosition < 160) { 
        currentPage = pdfDoc.addPage([currentPage.getWidth(), currentPage.getHeight()]);
        yPosition = 540; // Reset to top of new page
        drawHeader(currentPage); // Draw header on the new page too
      }

      currentPage.drawLine({
        start: { x: 40, y: yPosition },
        end: { x: 580, y: yPosition },
        thickness: 1,
        color: rgb(0, 0, 0),
      });
      currentPage.drawText("TOTAL", { x: 190, y: yPosition - 10, size: 9, font: calibriBold });
      currentPage.drawText(FormatValueToDecimal(totalVatable)?.toString() ?? "", { x: 290, y: yPosition - 10, size: 9, font: calibriBold });
      currentPage.drawText(FormatValueToDecimal(totalVAT)?.toString() ?? "", { x: 342.5, y: yPosition - 10, size: 9, font: calibriBold });
      currentPage.drawText(FormatValueToDecimal(totalSubTotal)?.toString() ?? "", { x: 382.5, y: yPosition - 10, size: 9, font: calibriBold });
      currentPage.drawText(FormatValueToDecimal(totalDiscount)?.toString() ?? "", { x: 442, y: yPosition - 10, size: 9, font: calibriBold });
      currentPage.drawText(FormatValueToDecimal(overallTotal)?.toString() ?? "", { x: 495, y: yPosition - 10, size: 9, font: calibriBold });


      // Save and Download PDF
      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }

    setLoading(false)
  }
//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasSalesRegister) {
    return <NoAccess />;
  }
//#endregion






//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <HistoryEduIcon fontSize="large" className="text-theme-color" />
              {`Sales Register`}
            </h2>
            <p className="text-gray-500 mt-1">Report of all Sales Invoices.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date From <span className="text-red-500">*</span>
            </label>
            <DateSelect data={dateFrom} setData={setDateFrom} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date To <span className="text-red-500">*</span>
            </label>
            <DateSelect data={dateTo} setData={setDateTo} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Company <span className="text-red-500">*</span>
            </label>
            <CompanySelect data={company} setData={setCompany} isEditable={true}/>
          </div>
        </div>

        <button onClick={generateHandleClick} className="mt-10 flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
          <RestartAltIcon fontSize="small" /> Generate
        </button>
      </div>

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}